import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="mt-20 border-t border-slate-200 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-6 gap-8">
      <div className="col-span-2">
        <div className="flex items-center gap-2">
          <img src="/advoset-logo.png" alt="Advoset" className="h-10 w-10 object-contain" />
          <span className="font-extrabold text-xl text-[#0A2540]" style={{ fontFamily: "Poppins" }}>Advoset</span>
        </div>
        <p className="text-sm text-slate-500 mt-3 leading-relaxed max-w-xs">
          Talk to a verified lawyer in minutes. From FIR to File — accessible, affordable, fear-free legal help for every Indian.
        </p>
        <div className="mt-4 flex items-center gap-4 text-xs text-slate-500">
          <span className="inline-flex items-center gap-1"><ShieldCheck size={13} className="text-emerald-600" /> Verified lawyers</span>
          <span className="inline-flex items-center gap-1"><Lock size={13} className="text-[#D4AF37]" /> Secure payments</span>
        </div>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider font-bold text-slate-400 mb-3">Product</p>
        <ul className="space-y-2 text-sm text-slate-700">
          <li><Link to="/lawyers" className="hover:text-[#0A2540]">Find Lawyer</Link></li>
          <li><Link to="/chat" className="hover:text-[#0A2540]">AI Assistant</Link></li>
          <li><Link to="/articles" className="hover:text-[#0A2540]">Knowledge Hub</Link></li>
          <li><Link to="/dashboard" className="hover:text-[#0A2540]">My Account</Link></li>
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider font-bold text-slate-400 mb-3">For Lawyers</p>
        <ul className="space-y-2 text-sm text-slate-700">
          <li><Link to="/become-a-lawyer" className="hover:text-[#0A2540]" data-testid="footer-become-a-lawyer">Apply to join</Link></li>
          <li><Link to="/lawyer-portal/login" className="hover:text-[#0A2540]">Lawyer login</Link></li>
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider font-bold text-slate-400 mb-3">Practice Areas</p>
        <ul className="space-y-2 text-sm text-slate-700">
          <li>Family Law</li>
          <li>Criminal Law</li>
          <li>Property Law</li>
          <li>Corporate & MSME</li>
          <li>Consumer Rights</li>
        </ul>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wider font-bold text-slate-400 mb-3">Disclaimer</p>
        <p className="text-xs text-slate-500 leading-relaxed">
          Advoset provides general legal information, not legal advice. Consultations connect you with independent verified lawyers.
        </p>
      </div>
    </div>
    <div className="border-t border-slate-100 py-5 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} Advoset · Made in India, for India
    </div>
  </footer>
);

export default Footer;
